import React, { useState, useEffect } from 'react';

import { createTotalRow } from './helpers';
import Currency from '../Row/Currency';

export default function TotalRow({
  cols,
  colsWithTotals,
  tableRef,
  totalTitle,
  rows,
}) {
  const [totalRow, setTotalRow] = useState([]);

  const withTotals = colsWithTotals?.length > 0;

  useEffect(() => {
    const total = createTotalRow({
      cols,
      colsWithTotals,
      tableRef,
    });

    setTotalRow(total);
  }, [cols, colsWithTotals, rows, tableRef]);

  if (!withTotals || !rows?.length) {
    return null;
  }

  return (
    <tr className="font-semibold" data-coltype="total">
      {cols.map((col, index) => {
        if (index === 0 && totalTitle) {
          return (
            <td key="totalTitle" className="px-2 first:pl-5 last:pr-5 py-3">
              <div className="text-left flex items-center">{totalTitle}</div>
            </td>
          );
        }

        const value = totalRow.find((row) => row.title === col.title)?.value;

        if (value === undefined) {
          return <td key={col.title} />;
        }

        return (
          <td key={col.title} className="px-2 first:pl-5 last:pr-5 py-3">
            <div className="text-left flex items-center">
              <Currency value={value} />
            </div>
          </td>
        );
      })}
    </tr>
  );
}
